<!--
 * @Description  : 12306登录提示条
-->
<template>
  <view wx:if="{{show}}" class="container">
    <view class="content">
      <image class="train" src="{{trainIconUrl}}"></image>
      <text class="text">登录12306 享官方直购</text>
    </view>
    <view class="action">
      <view bindtap="toLoginPage" class="btn">立即登录</view>
      <es-icon bind:click="close" custom-class="close" name="close-filled" size="15"></es-icon>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { innerRouter, pagePath } from '@/common/jump'
  import { to12306LoginPage } from '@/common/pageJump'
  import { setStorage } from '@/utils/storage'
  import { calcDateNum } from '@/utils/baseDate'

  createComponent({
    data() {
      return {
        trainIconUrl: 'https://ut-static.udache.com/webx/sfc/ptoBIVlJ7zqUh7XDAmQKx.png',
      }
    },
    computed: {
      ...store.mapGetters({
        isHomeLoginValidate: 'login12306.isHomeLoginValidate',
      }),
      ...store.mapState({
        homeLoginTipVisible: 'login12306.homeLoginTipVisible',
      }),
      show() {
        return !this.isHomeLoginValidate && this.homeLoginTipVisible
      }
    },
    methods: {
      ...store.mapMutations({
        setHomeLoginTipStatus: 'login12306.setHomeLoginTipStatus',
      }),
      close() {
        this.setHomeLoginTipStatus(false)
        setStorage({
          key: 'home_to_login_tip_visible_close_time',
          data: new Date().getTime()
        })
      },
      toLoginPage() {
        to12306LoginPage({
          isIndex: 'current'
        })
      }
    }
  })
</script>

<style scoped lang="stylus" src="./style.styl"></style>

<script name="json">
  module.exports = {
    component: true,
  }
</script>